import React from 'react';
import {Container, Nav, Navbar} from "react-bootstrap";
import logo from "../assets/images/logo192.png";

MyNavbar.propTypes = {};

function MyNavbar() {
    return (
        <Navbar sticky={"top"} variant={"dark"} style={{backgroundColor: "black"}}>
            <Container>
                <Navbar.Brand>
                    <img src={logo} alt="logo" width="30" height="30" className="d-inline-block align-top"/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/privacy">Privacy</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default MyNavbar;